import { render, staticRenderFns } from "./ClubhouseinJapanJP.vue?vue&type=template&id=b304ccd4"
import script from "./ClubhouseinJapanJP.vue?vue&type=script&lang=js"
export * from "./ClubhouseinJapanJP.vue?vue&type=script&lang=js"
import style0 from "./ClubhouseinJapanJP.vue?vue&type=style&index=0&id=b304ccd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports